(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';
    console.log('[VF Cart] Initializing...');

    const drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      console.warn('[VF Cart] Drawer element not found');
      return;
    }

    let isOpen = false;
    let isLoading = false;

    function openDrawer() {
      console.log('[VF Cart] Opening drawer');
      isOpen = true;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      console.log('[VF Cart] Closing drawer');
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // ===== OPEN TRIGGERS =====
    // 1. Custom event
    document.addEventListener('velvetfeel:cart:open', function() {
      console.log('[VF Cart] Open event received');
      openDrawer();
    });

    // 2. Direct click on cart buttons
    document.addEventListener('click', function(e) {
      const cartTrigger = e.target.closest('#VFCartBtn, [data-cart-open], .header__icon--cart, .vf-header__icon--cart, [aria-label="Cart"], [aria-label="cart"], [aria-label="Open cart"]');
      if (cartTrigger) {
        // Don't intercept if it's a link to cart page with no JS
        if (cartTrigger.tagName === 'A' && cartTrigger.getAttribute('href') && !cartTrigger.hasAttribute('data-cart-open')) {
          // It's a link - intercept and open drawer instead
          e.preventDefault();
        } else {
          e.preventDefault();
        }
        console.log('[VF Cart] Cart trigger clicked', cartTrigger);
        openDrawer();
      }
    });

    // ===== CLOSE TRIGGERS =====
    drawer.querySelectorAll('[data-cart-close]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    // ===== UPDATE CART COUNT EVERYWHERE =====
    function updateCartCount(count) {
      const badges = document.querySelectorAll('#CartCount, .vf-header__cart-count, [data-cart-count]');
      badges.forEach(function(b) {
        if (count > 0) {
          b.textContent = count > 99 ? '99+' : count;
          b.removeAttribute('hidden');
          b.style.display = '';
        } else {
          b.setAttribute('hidden', '');
          b.style.display = 'none';
        }
      });
      const countText = drawer.querySelector('[data-cart-count-text]');
      if (countText) countText.textContent = count > 0 ? '(' + count + ')' : '';
    }

    // ===== CART UPDATED EVENT =====
    document.addEventListener('velvetfeel:cart:updated', function(e) {
      console.log('[VF Cart] Cart updated event', e.detail);
      const count = e.detail && e.detail.count !== undefined ? e.detail.count : 0;
      updateCartCount(count);

      // Refresh drawer content via fetch (without page reload)
      fetchAndUpdateDrawer();
    });

    // ===== FETCH AND UPDATE DRAWER WITHOUT RELOAD =====
    async function fetchAndUpdateDrawer() {
      if (isLoading) return;
      isLoading = true;

      try {
        const response = await fetch(window.location.pathname, {
          headers: { 'Accept': 'text/html' }
        });
        const html = await response.text();
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        const newDrawer = newDoc.getElementById('CartDrawer');

        if (newDrawer) {
          const wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
          }
          // Re-bind close buttons on new content
          drawer.querySelectorAll('[data-cart-close]').forEach(function(el) {
            el.addEventListener('click', function(ev) {
              ev.preventDefault();
              closeDrawer();
            });
          });
        }
      } catch (err) {
        console.error('[VF Cart] Refresh failed:', err);
      } finally {
        isLoading = false;
      }
    }

    // ===== QUANTITY & REMOVE =====
    drawer.addEventListener('click', async function(e) {
      const inc = e.target.closest('[data-cart-inc]');
      const dec = e.target.closest('[data-cart-dec]');
      const rem = e.target.closest('[data-cart-remove]');
      const save = e.target.closest('[data-cart-save]');

      if (!inc && !dec && !rem && !save) return;
      e.preventDefault();

      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const key = item.dataset.key;
      const handle = item.dataset.handle;
      const qtyEl = item.querySelector('.vfc-item__qty-value');
      let qty = parseInt(qtyEl ? qtyEl.textContent : '1') || 1;

      if (save && handle) {
        try {
          let saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
          if (!saved.includes(handle)) {
            saved.push(handle);
            localStorage.setItem('vf_wishlist', JSON.stringify(saved));
          }
        } catch(err) {}
        qty = 0;
      }

      if (inc) qty++;
      if (dec) qty = Math.max(0, qty - 1);
      if (rem) qty = 0;

      if (qty === 0) item.classList.add('is-removing');

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
          detail: { count: cart.item_count, cart: cart }
        }));
      } catch(err) {
        console.error('[VF Cart] Change failed:', err);
        item.classList.remove('is-removing');
      }
    });

    // ===== NOTES (debounced auto-save) =====
    let noteTimer = null;
    drawer.addEventListener('input', function(e) {
      const noteInput = e.target.closest('[data-cart-note]');
      if (!noteInput) return;

      clearTimeout(noteTimer);
      noteTimer = setTimeout(async function() {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteInput.value })
          });
        } catch(err) {
          console.error('[VF Cart] Note save failed:', err);
        }
      }, 800);
    });

    // ===== DISCOUNT CODE =====
    drawer.addEventListener('submit', async function(e) {
      const form = e.target.closest('[data-discount-form]');
      if (!form) return;
      e.preventDefault();

      const input = form.querySelector('[data-discount-input]');
      const result = drawer.querySelector('[data-discount-result]');
      const code = input.value.trim();
      if (!code) return;

      result.textContent = 'Applying...';
      result.className = 'vfc__discount-result';

      try {
        const res = await fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          credentials: 'same-origin'
        });

        if (res.ok || res.redirected) {
          result.textContent = '✓ Code "' + code + '" will apply at checkout';
          result.classList.add('is-success');
          sessionStorage.setItem('vf_discount', code);
        } else {
          throw new Error('Invalid');
        }
      } catch(err) {
        result.textContent = '✕ Invalid or expired code';
        result.classList.add('is-error');
      }
    });

    // ===== APPLY DISCOUNT ON CHECKOUT =====
    drawer.addEventListener('click', function(e) {
      const checkoutBtn = e.target.closest('.vfc__checkout');
      if (!checkoutBtn) return;
      const code = sessionStorage.getItem('vf_discount');
      if (code) {
        e.preventDefault();
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      }
    });

    console.log('[VF Cart] Ready ✓');
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vf-age-gate"] && !Shopify.designMode) return;
  try {
    (function () {

    const STORAGE_KEY = 'vf_age_verified';
  

    const gate      = document.getElementById('VFAgeGate');
    if (!gate) return;

    const modal     = gate.querySelector('.vf-age-gate__modal');
    const denied    = gate.querySelector('.vf-age-gate__denied');
    const confirmBtn = gate.querySelector('[data-age-confirm]');
    const denyBtn    = gate.querySelector('[data-age-deny]');

        /* ── Storage helpers — session only ─────────── */
    function isVerified () {
      try {
        return sessionStorage.getItem(STORAGE_KEY) === 'true';
      } catch (e) {
        return false;
      }
    }

    function setVerified () {
      try {
        sessionStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {}
    }

    /* ── Open / Close ────────────────────────────── */
    function openGate () {
      gate.hidden = false;
      document.body.classList.add('vf-age-locked');
      /* rAF ensures the transition triggers */
      requestAnimationFrame(() => gate.classList.add('is-open'));
      /* Focus first action for accessibility */
      setTimeout(() => confirmBtn?.focus(), 400);
    }

    function closeGate () {
      gate.classList.remove('is-open');
      document.body.classList.remove('vf-age-locked');
      setTimeout(() => { gate.hidden = true; }, 400);
    }

    /* ── Handlers ────────────────────────────────── */
    confirmBtn?.addEventListener('click', () => {
      setVerified();
      closeGate();
    });

    denyBtn?.addEventListener('click', () => {
      modal.hidden = true;
      denied.hidden = false;
      /* Optional: redirect after a beat */
      setTimeout(() => {
        window.location.href = 'https://www.google.com';
      }, 2500);
    });

    /* ── Focus trap (basic) ─────────────────────── */
    gate.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = gate.querySelectorAll('button, a[href]');
      const visible = Array.from(focusable).filter(el => el.offsetParent !== null);
      if (!visible.length) return;
      const first = visible[0];
      const last  = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    /* ── Init ────────────────────────────────────── */
    if (!isVerified()) {
      /* Slight delay so page paints first */
      setTimeout(openGate, 200);
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vf-back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {

    const btn   = document.getElementById('VFBackTop');
    if (!btn) return;

    const fill        = btn.querySelector('.vf-back-top__ring-fill');
    const SHOW_AT     = 400;   // px scrolled before button appears
    let   ticking     = false;

    /* ── Scroll handler ─────────────────────────────── */
    function onScroll () {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        const scrollY   = window.scrollY;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const progress  = maxScroll > 0 ? (scrollY / maxScroll) * 100 : 0;

        /* Show / hide */
        if (scrollY > SHOW_AT) {
          btn.hidden = false;
          /* rAF tick gives browser a frame to paint before fading in */
          requestAnimationFrame(() => btn.classList.add('is-visible'));
        } else {
          btn.classList.remove('is-visible');
          /* Wait for fade-out before setting hidden */
          btn.addEventListener(
            'transitionend',
            () => { if (!btn.classList.contains('is-visible')) btn.hidden = true; },
            { once: true }
          );
        }

        /* Progress ring — dashoffset: 100 = empty, 0 = full */
        if (fill) {
          fill.style.strokeDashoffset = (100 - progress).toFixed(2);
        }

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load

    /* ── Click handler ──────────────────────────────── */
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* ── Keyboard: Enter / Space already fire click,
          but ensure focus returns cleanly ─────────── */
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vf-quick-view"] && !Shopify.designMode) return;
  try {
    (function() {
    const modal = document.getElementById('VFQuickView');
    if (!modal) return;

    const content = modal.querySelector('[data-qv-content]');
    let currentProduct = null;
    let selectedVariantId = null;

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        content.innerHTML = '<div class="vfqv__loading"><div class="vfqv__spinner"></div></div>';
      }, 500);
    }

    modal.querySelectorAll('[data-qv-close]').forEach(el => {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    function formatPrice(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    async function fetchProduct(handle) {
      try {
        const res = await fetch('/products/' + handle + '.js');
        if (!res.ok) return null;
        return await res.json();
      } catch (e) { return null; }
    }

    function renderProduct(product) {
      currentProduct = product;
      const variant = product.variants.find(v => v.available) || product.variants[0];
      selectedVariantId = variant ? variant.id : null;
      const onSale = product.compare_at_price && product.compare_at_price > product.price;
      const discountPct = onSale ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100) : 0;

      let optionsHTML = '';
      if (product.variants.length > 1) {
        product.options.forEach((optName, optIdx) => {
          const values = [...new Set(product.variants.map(v => v.options[optIdx]))];
          optionsHTML += `
            <div class="vfqv__option" data-option-index="${optIdx}">
              <span class="vfqv__option-label">
                <span>${optName}:</span>
                <span class="vfqv__option-value" data-qv-selected="${optIdx}">${variant.options[optIdx]}</span>
              </span>
              <div class="vfqv__option-pills">
                ${values.map(v => `
                  <button type="button" class="vfqv__pill${v === variant.options[optIdx] ? ' is-active' : ''}" data-qv-option-value="${v}" data-qv-option-index="${optIdx}">${v}</button>
                `).join('')}
              </div>
            </div>
          `;
        });
      }

      content.innerHTML = `
        <div class="vfqv__layout">
          <div class="vfqv__media">
            ${product.featured_image ? `<img class="vfqv__img" src="${product.featured_image}" alt="${product.title}" data-qv-image>` : ''}
          </div>
          <div class="vfqv__info">
            ${product.vendor ? `<p class="vfqv__vendor">${product.vendor}</p>` : ''}
            <h2 class="vfqv__title">${product.title}</h2>
            <div class="vfqv__price">
              <span class="vfqv__price-now" data-qv-price>${formatPrice(product.price)}</span>
              ${onSale ? `<span class="vfqv__price-was">${formatPrice(product.compare_at_price)}</span>` : ''}
              ${onSale ? `<span class="vfqv__price-save">Save ${discountPct}%</span>` : ''}
            </div>
            ${product.description ? `<p class="vfqv__desc">${product.description.replace(/<[^>]+>/g, '').slice(0, 200)}...</p>` : ''}
            ${optionsHTML}
            <div class="vfqv__actions">
              <button type="button" class="vfqv__add" data-qv-add ${!variant || !variant.available ? 'disabled' : ''}>
                <span>${!variant || !variant.available ? 'Sold Out' : 'Add to Bag'}</span>
                ${variant && variant.available ? '<svg viewBox="0 0 32 12" fill="none"><path d="M0 6h30M24 1l6 5-6 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : ''}
              </button>
              <a href="/products/${product.handle}" class="vfqv__view-full">View Full Details</a>
            </div>
          </div>
        </div>
      `;
    }

    // Handle option selection
    content.addEventListener('click', async (e) => {
      const pill = e.target.closest('[data-qv-option-value]');
      const addBtn = e.target.closest('[data-qv-add]');

      if (pill && currentProduct) {
        const optIdx = parseInt(pill.dataset.qvOptionIndex);
        const value = pill.dataset.qvOptionValue;

        // Update active pill
        pill.parentElement.querySelectorAll('.vfqv__pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        // Update selected label
        const selectedSpan = content.querySelector(`[data-qv-selected="${optIdx}"]`);
        if (selectedSpan) selectedSpan.textContent = value;

        // Find matching variant
        const selectedOpts = [];
        content.querySelectorAll('.vfqv__option').forEach(optEl => {
          const active = optEl.querySelector('.vfqv__pill.is-active');
          if (active) selectedOpts.push(active.dataset.qvOptionValue);
        });

        const matchedVariant = currentProduct.variants.find(v =>
          v.options.every((opt, i) => opt === selectedOpts[i])
        );

        if (matchedVariant) {
          selectedVariantId = matchedVariant.id;
          const priceEl = content.querySelector('[data-qv-price]');
          if (priceEl) priceEl.textContent = formatPrice(matchedVariant.price);

          const imgEl = content.querySelector('[data-qv-image]');
          if (imgEl && matchedVariant.featured_image) {
            imgEl.src = matchedVariant.featured_image.src;
          }

          const btn = content.querySelector('[data-qv-add]');
          if (btn) {
            btn.disabled = !matchedVariant.available;
            btn.querySelector('span').textContent = matchedVariant.available ? 'Add to Bag' : 'Sold Out';
          }
        }
      }

      if (addBtn && !addBtn.disabled && selectedVariantId) {
        const textSpan = addBtn.querySelector('span');
        const original = textSpan.textContent;
        addBtn.disabled = true;
        textSpan.textContent = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
          });

          if (!res.ok) throw new Error('Failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
            detail: { count: cart.item_count, cart: cart }
          }));

          textSpan.textContent = '✓ Added';
          setTimeout(() => {
            close();
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('velvetfeel:cart:open'));
            }, 300);
          }, 800);
        } catch (err) {
          textSpan.textContent = 'Try Again';
          setTimeout(() => {
            textSpan.textContent = original;
            addBtn.disabled = false;
          }, 1500);
        }
      }
    });

    // Open trigger - any element with data-quickview attribute containing handle
    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest('[data-quickview]');
      if (!trigger) return;

      e.preventDefault();
      const handle = trigger.dataset.quickview;
      if (!handle) return;

      open();
      const product = await fetchProduct(handle);
      if (product) {
        renderProduct(product);
      } else {
        content.innerHTML = '<div style="padding:40px;text-align:center;">Could not load product.</div>';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vf-search-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    const drawer = document.getElementById('VFSearchDrawer');
    if (!drawer) return;

    const input = drawer.querySelector('[data-search-input]');
    const clear = drawer.querySelector('[data-search-clear]');
    const defaultView = drawer.querySelector('[data-search-default]');
    const resultsView = drawer.querySelector('[data-search-results]');
    const loadingView = drawer.querySelector('[data-search-loading]');
    const emptyView = drawer.querySelector('[data-search-empty]');

    let searchTimeout = null;
    let currentSearch = '';

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input?.focus(), 400);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Open triggers
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-search-open], #HeaderSearchToggle, .vf-header__icon[aria-label="Search"]');
      if (trigger) {
        e.preventDefault();
        openDrawer();
      }
    });

    // Close triggers
    drawer.querySelectorAll('[data-search-close]').forEach(el => {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Clear
    clear?.addEventListener('click', () => {
      input.value = '';
      input.focus();
      showDefault();
    });

    function showDefault() {
      defaultView.hidden = false;
      resultsView.hidden = true;
      loadingView.hidden = true;
      emptyView.hidden = true;
      clear.hidden = true;
    }

    function showLoading() {
      defaultView.hidden = true;
      resultsView.hidden = true;
      loadingView.hidden = false;
      emptyView.hidden = true;
    }

    function showResults() {
      defaultView.hidden = true;
      resultsView.hidden = false;
      loadingView.hidden = true;
      emptyView.hidden = true;
    }

    function showEmpty() {
      defaultView.hidden = true;
      resultsView.hidden = true;
      loadingView.hidden = true;
      emptyView.hidden = false;
    }

    // Live search
    input?.addEventListener('input', () => {
      const q = input.value.trim();
      clear.hidden = q.length === 0;

      clearTimeout(searchTimeout);

      if (q.length < 2) {
        showDefault();
        return;
      }

      searchTimeout = setTimeout(() => performSearch(q), 250);
    });

    async function performSearch(q) {
      if (q === currentSearch) return;
      currentSearch = q;
      showLoading();

      try {
        const res = await fetch(
          `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8`
        );
        const data = await res.json();

        if (q !== currentSearch) return; // outdated

        const products = data?.resources?.results?.products || [];
        const collections = data?.resources?.results?.collections || [];

        if (products.length === 0 && collections.length === 0) {
          showEmpty();
          return;
        }

        let html = '';

        if (products.length > 0) {
          html += '<div class="vfs-drawer__results-section">';
          html += '<p class="vfs-drawer__section-title"><span class="vfs-drawer__section-line"></span><span>Products</span></p>';
          html += '<div class="vfs-drawer__results-grid">';
          products.slice(0, 8).forEach(p => {
            const img = p.featured_image ? p.featured_image.url || p.featured_image : '';
            const price = p.price ? formatMoney(p.price) : '';
            html += `
              <a href="${p.url}" class="vfs-result">
                <div class="vfs-result__img">
                  ${img ? `<img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
                </div>
                <p class="vfs-result__title">${escapeHtml(p.title)}</p>
                <p class="vfs-result__price">${price}</p>
              </a>
            `;
          });
          html += '</div></div>';
        }

        if (collections.length > 0) {
          html += '<div class="vfs-drawer__results-section">';
          html += '<p class="vfs-drawer__section-title"><span class="vfs-drawer__section-line"></span><span>Collections</span></p>';
          html += '<div class="vfs-drawer__chips">';
          collections.slice(0, 6).forEach(c => {
            html += `<a href="${c.url}" class="vfs-drawer__chip">${escapeHtml(c.title)}</a>`;
          });
          html += '</div></div>';
        }

        html += `
          <div class="vfs-drawer__view-all">
            <a href="/search?q=${encodeURIComponent(q)}" class="vfs-drawer__view-all-link">
              <span>View All Results</span>
              <svg viewBox="0 0 32 12" fill="none"><path d="M0 6h30M24 1l6 5-6 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
          </div>
        `;

        resultsView.innerHTML = html;
        showResults();
      } catch (err) {
        console.error('Search error:', err);
        showEmpty();
      }
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return `₹${amount}`;
    }

    // Submit goes to full search page
    drawer.querySelector('[data-search-form]')?.addEventListener('submit', () => {
      // Let it submit naturally
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
